import type { ReactNode } from 'react';

import {
  useAddToCartMutation,
  useQuantityInCart,
  useChangeCartQuantityMutation,
} from '@site-builder/block-helpers';

import { StoreCardContext } from './store-card-context';
import { findMinAvailableLimit } from '../../utils/limit';

import type { AnyItem } from '@site-builder/block-utils';

interface StoreCardWrapperProps {
  readonly item: AnyItem;
  readonly onPurchase?: () => void;
  readonly children?: ReactNode;
}

export const StoreCardWrapper = ({
  item,
  onPurchase,
  children,
}: StoreCardWrapperProps) => {
  const addToCart = useAddToCartMutation();
  const changeQuantityInCart = useChangeCartQuantityMutation();
  const quantityInCart = useQuantityInCart(item);

  const availableLimit = findMinAvailableLimit(item.limits);

  const contextValue = {
    item,
    quantityInCart,
    availableAmount: availableLimit?.available ?? 0,
    maxAvailableAmount: availableLimit?.total ?? 0,
    onPurchase,
    onAddToCart: () => addToCart.mutate(item),
    onInCartIncrement: () =>
      changeQuantityInCart.mutate({ item, quantity: 'increment' }),
    onInCartDecrement: () =>
      changeQuantityInCart.mutate({ item, quantity: 'decrement' }),
  };

  return (
    <StoreCardContext.Provider value={contextValue}>
      {children}
    </StoreCardContext.Provider>
  );
};
